import axios from "axios";

const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
/** Same-origin `/api` in production (nginx → backend); full URL in dev. */
export const API_BASE = BACKEND_URL ? `${BACKEND_URL}/api` : "/api";
export const TOKEN_KEY = "ss_admin_token";

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && typeof window !== "undefined") {
      const path = window.location.pathname;
      if (path.startsWith("/admin") && path !== "/admin/login") {
        localStorage.removeItem(TOKEN_KEY);
        window.location.assign("/admin/login");
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" · ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function formatApiError(err) {
  if (err?.response?.status === 413) {
    return "Request is too large. Please use a smaller image (max 2 MB) and try again.";
  }
  return formatApiErrorDetail(err?.response?.data?.detail);
}

export function pickImage(feature) {
  return feature?.image_url || feature?.image_data || "";
}
